let groupCount = 0;

export default class Accordion {
	/**
	 * @param {HTMLElement} element
	 */
	constructor(element) {
		this.element = element;

		const groupName = `accordion-group-${groupCount++}`;

		/** @type {HTMLDetailsElement[]} */
		this.details = [...element.querySelectorAll(".Accordion-item details")];

		this.details.forEach((detail) => {
			detail.name = groupName;
			detail.addEventListener("toggle", () => {
				this.#onToggle(detail);
			});
		});

		this.#preOpen();
	}

	/**
	 * @param {HTMLDetailsElement} detail
	 */
	#onToggle(detail) {
		if (detail.open) {
			window.history.replaceState(null, "", `#${detail.id}`);
		} else if (!this.details.some((detail) => detail.open)) {
			window.history.replaceState(null, "", " ");
		}
	}

	#preOpen() {
		const { hash } = window.location;

		if (!hash) {
			return;
		}

		/** @type {HTMLDetailsElement|null} */
		const target = this.element.querySelector(hash);

		if (!target) {
			return;
		}

		target.open = true;
	}
}
